import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "../utils/exportPDF";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const StockRegisterReport = () => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user_id, setUserId] = useState("");
  const [getSelectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("selectedMenu") || ""
  );

  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0); // last day of month

    // Format as YYYY-MM-DD
    const formatDate = (date) =>
      date.toISOString().split("T")[0];

    return {
      start_date: formatDate(start),
      end_date: formatDate(end),
    };
  };

  const [filters, setFilters] = useState(getCurrentMonthDates());
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    localStorage.setItem("selectedMenu", getSelectedMenu);
  }, [getSelectedMenu]);

  useEffect(() => {
    const userid = localStorage.getItem("user_id");
    if (userid) setUserId(userid);
  }, []);

  useEffect(() => {
    if (user_id) {
      fetchPurchases();
    }
  }, [user_id, currentPage, filters]);

  const fetchPurchases = async (e) => {
    if (e) e.preventDefault();

    setLoading(true);
    try {
      const requestData = {
        user_id: user_id,
        start_data: filters.start_date || "",
        end_data: filters.end_date || "",
      };

      // Send as POST with JSON body
      const response = await axios.post("https://api-ims.indevconsultancy.in/StockRegisterReport.php", requestData, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.data && response.data.status && Array.isArray(response.data.data)) {
        const allData = response.data.data;
        setTotalItems(allData.length);

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedData = allData.slice(startIndex, endIndex);
        console.log('paginatedData', paginatedData);

        setPurchases(paginatedData);
        setTotalPages(Math.ceil(allData.length / itemsPerPage));
      } else {
        setPurchases([]);
        setTotalItems(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Error fetching purchases:", error);
      setPurchases([]);
    } finally {
      setLoading(false);
    }
  };


  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB");
  };

  // ✅ Export API Call - Updated for new API
  // Also update the export function to use POST
  const handleExportCSV = async () => {
    setLoading(true);
    try {
      // First, fetch all data without pagination
      const requestData = {
        user_id: user_id,
        start_data: filters.start_date || "",
        end_data: filters.end_date || "",
      };

      const response = await axios.post(
        "https://api-ims.indevconsultancy.in/StockRegisterReport.php",
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (response.data && response.data.status && Array.isArray(response.data.data)) {
        const allData = response.data.data;

        // Convert to CSV
        const headers = ["Purchase No", "Item Name", "Opening", "Purchasing", "Consuming", "Closing"];

        const csvRows = [
          headers.join(','),
          ...allData.map((item, index) => {
            const row = [
              index + 1,
              `"${(item.stock_name || "N/A").replace(/"/g, '""')}"`,
              `"${item.opening_quantity || ""}"`,
              `"${item.purchased_quantity || "0"} Kg"`,
              `"${item.consumed_quantity || "0"} Kg"`,
              `"${item.available_quantity || "0"} Kg"`
            ];
            return row.join(',');
          })
        ];

        // Create CSV content
        const csvContent = csvRows.join('\n');

        // Create and trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const today = new Date().toISOString().split('T')[0];
        const filename = `receipt-report-${today}.csv`;

        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        alert("No data available to export");
      }

    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Export failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleExportPDF = async () => {
    setLoading(true);
    try {
      const requestData = {
        user_id: user_id,
        start_data: filters.start_date || "",
        end_data: filters.end_date || "",
      };
      const response = await axios.post(
        "https://api-ims.indevconsultancy.in/StockRegisterReport.php",
        requestData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data && response.data.status && Array.isArray(response.data.data)) {
        const allData = response.data.data;
        const headers = ["S.No.", "Item Name", "Opening", "Purchased", "Consumed", "Available"];
        const rows = allData.map((item, index) => [
          index + 1,
          item.stock_name || "N/A",
          item.opening_quantity || "",
          (item.purchased_quantity || "0") + " Kg",
          (item.consumed_quantity || "0") + " Kg",
          (item.available_quantity || "0") + " Kg",
        ]);
        const today = new Date().toISOString().split("T")[0];
        exportTableToPDF({ title: "Stock Register Report", headers, rows, filename: `stock-register-${today}.pdf`, filterInfo: `Total: ${rows.length}` });
      } else {
        alert("No data available to export");
      }
    } catch (error) {
      console.error("Error exporting PDF:", error);
      alert("Export failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle reset
  const handleReset = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    setCurrentPage(1);
  };

  if (loading && purchases.length === 0) return <p>Loading...</p>;

  return (
    <div className="container-fluid px-2">
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <span className="fs-1">Receipt Report</span>
        </div>

        <div className="col-md-6 col-6 text-end">
          <div className="bg-light p-2 rounded d-inline-flex align-items-center justify-content-end">
            <span className="me-1">Receipt Report</span>
            <span className="mx-1">/</span>
            <Link to="/purchaseDashboard">Home</Link>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="row g-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header border-info">
              <form
                onSubmit={(e) => {
                  setCurrentPage(1);
                  fetchPurchases(e);
                }}
              >
                <div className="row g-3">
                  <div className="col-lg">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={filters.start_date}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      name="end_date"
                      className="form-control"
                      value={filters.end_date}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-2 d-flex align-items-end">
                    <button type="submit" className="btn btn-primary w-100">
                      Search
                    </button>
                  </div>
                  <div className="col-lg-1 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-outline-dark w-100"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="card-body">
              <div className="row g-0 align-items-center">
                <div className="col-sm-7 mb-3">
                  <h6 className="fw-bold mb-0">
                    Total Items(s): <span>{totalItems}</span>
                  </h6>
                </div>
                <div className="col-sm-5 mb-3 text-end">
                  <button
                    className="btn btn-primary btn-sm me-1"
                    onClick={handleExportCSV}
                    type="button"
                    disabled={loading}
                  >
                    <i className="fas fa-file-csv"></i> Export CSV
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={handleExportPDF}
                    type="button"
                    disabled={loading}
                  >
                    <i className="fas fa-file-pdf"></i> Export PDF
                  </button>
                </div>
              </div>
              {/* Table */}
              <div className="table-responsive scrollbar">
                <table className="table text-center table-bordered table-striped fs--1 mb-0">
                  <thead className="bg-primary text-white">
                    <tr>
                      <th>Purchase No</th>
                      <th>Item Name</th>
                      <th>Opening</th>
                      <th>Purchasing</th>
                      <th>Consuming</th>
                      <th>Closing</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && purchases.length === 0 ? (
                      <tr>
                        <td colSpan="6">Loading...</td>
                      </tr>
                    ) : purchases.length === 0 ? (
                      <tr>
                        <td colSpan="6">No data available</td>
                      </tr>
                    ) : (
                      purchases.map((purchase, index) => (
                        <tr key={`${purchase.parchase_id}-${index}`}>
                          <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                          <td>{purchase.stock_name || "N/A"}</td>
                          <td>{purchase.opening_quantity}</td>
                          <td>{purchase.purchased_quantity || "0"} Kg</td>
                          <td>{purchase.consumed_quantity || "0"} Kg</td>
                          <td>{purchase.available_quantity || "0"} Kg</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1 || loading}
                  >
                    Previous
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() =>
                      setCurrentPage((prev) =>
                        Math.min(prev + 1, totalPages)
                      )
                    }
                    disabled={currentPage === totalPages || loading}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockRegisterReport;